import React, { useEffect } from 'react';
import styles from './title.module.scss';

function TitleComponent(props: any) {

    useEffect(() => {

    }, [])

    return (
        <div className={styles.header}>
                <div className={styles.title_content}>
                    <div className={styles.title}>{props.title}</div>
                    <div className={styles.info}>{props.subTitle}</div>
                </div>
            </div>
    )

}

export default TitleComponent;